'use client';

import Image from 'next/image';

import {
  RecoveryPasswordForm,
  SplashScreen,
  StyledGridBox,
  StyledHeader,
  StyledLoginFormBox,
  StyledTextCall,
  StyledThemeButtonBox,
} from '~/entities';
import { ThemeButton } from '~/features';

export function RecuperacaoSenhaView() {
  return (
    <StyledGridBox>
      <StyledThemeButtonBox>
        <ThemeButton />
      </StyledThemeButtonBox>
      <SplashScreen />
      <StyledLoginFormBox>
        <Image
          className="mobile-logo"
          src="/static/logo_martins_ads.svg"
          alt="Logo da Martins Ads"
          width={100}
          height={103}
        />
        <StyledHeader variant="h1">Recuperação de senha</StyledHeader>
        <StyledTextCall>
          Informe seu e-mail para resetar sua senha.
        </StyledTextCall>

        <RecoveryPasswordForm />
      </StyledLoginFormBox>
    </StyledGridBox>
  );
}
